import { CommandBarButton, MessageBarType } from "office-ui-fabric-react";
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import Actions from "../../redux/Actions";
import { IRootState } from "../../store";
import DispatchProps from "../../utils/DispatchProps";
import ApiService from "../ApiService";
import {DurableFunctionInstance} from "../../models/DurableFunctionInstance";

export interface AutomationControlsProps {
    tenantId: string;
    sdsProfileId?: string;
    automationLoopInstance?: DurableFunctionInstance | null | undefined;
    onChange: () => Promise<void>;

    apiService: ApiService;
}

export interface AutomationControlsState {

}

class AutomationControls extends Component<AutomationControlsProps & DispatchProps, AutomationControlsState> {

    constructor(props: AutomationControlsProps & DispatchProps) {
        super(props);

        this.state = {};
    }

    public async componentDidMount() {

    }
    
    private async startUpload() {
        try {
            if (this.props.sdsProfileId != undefined) {
                await this.props.apiService.triggerAutomationUpload(this.props.tenantId, this.props.sdsProfileId);
                this.props.dispatch(Actions.showMessageBar(`Automation: Upload request successful`, MessageBarType.success));
                await this.props.onChange();
            }
            else {
                this.props.dispatch(Actions.showMessageBar(`No SDS Flow has been set for this school`, MessageBarType.warning));
            }
        }
        catch (e) {
            console.log(e);
            this.props.dispatch(Actions.showMessageBar(`Unable to start upload. Make sure automation is turned on`, MessageBarType.error));
        }
    }

    private async startAutomation() {
        try {
            if (this.props.sdsProfileId != undefined) {
                await this.props.apiService.startAutomation(this.props.tenantId, this.props.sdsProfileId);
                this.props.dispatch(Actions.showMessageBar(`Automation: Start request successful`, MessageBarType.success));
                await this.props.onChange();
            }
            else {
                this.props.dispatch(Actions.showMessageBar(`No SDS Flow has been set for this school`, MessageBarType.warning));
            }
        }
        catch (e) {
            console.log(e);
            this.props.dispatch(Actions.showMessageBar(`Unable to start automation: ${e}`, MessageBarType.error));
        }
    }

    private async terminateInstance() {
        try {
            if (this.props.automationLoopInstance != undefined) {
                await this.props.apiService.terminateMailroomDurableFunction(this.props.automationLoopInstance.durableFunctionInstanceId);
                this.props.dispatch(Actions.showMessageBar(`Automation: Terminate request successful`, MessageBarType.success));
                this.props.onChange();
            }
        }
        catch (e) {
            console.log(e);
            this.props.dispatch(Actions.showMessageBar(`Error terminating instance`, MessageBarType.error));
        }
    }
    

    
    private getStateButton() {
        if (this.props.automationLoopInstance?.runtimeStatus == "Running") {
            // Stop automation
            return <CommandBarButton
                iconProps={{ iconName: "blocked" }}
                text="Stop Automation"
                onClick={() => this.terminateInstance()}
            />
        } else {
            // Start Automation
            return <CommandBarButton
                iconProps={{ iconName: "play" }}
                text="Start Automation"
                onClick={() => this.startAutomation()}
            />
        }
    }

    public render() {
        return (
            <Fragment>
                <CommandBarButton
                    iconProps={{ iconName: "upload" }}
                    text="Start Manual Upload"
                    onClick={() => this.startUpload()}
                    disabled={this.props.sdsProfileId == undefined}
                />
                {this.getStateButton()}
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: { tenantId: string, sdsProfileId?: string,automationLoopInstance: DurableFunctionInstance | null | undefined, onChange: () => Promise<void> }): AutomationControlsProps => {
        return {
            tenantId: ownProps.tenantId,
            sdsProfileId: ownProps.sdsProfileId,
            automationLoopInstance: ownProps.automationLoopInstance,
            onChange: ownProps.onChange,
            apiService: state.auth.apiService
        };
    }
)(AutomationControls);